import { Context, Id, ObservableValue } from '../../../common'
import { StorageInfo } from '../../events'
import { Update, UpdatePlatform } from '../../updates'

export enum AppType {
  WEB = 'web',
  DESKTOP = 'desktop',
}

export interface ExportOpts {
  path: string
  writeDistro: boolean
  writeData: boolean
  createAuthCode: boolean
  platform?: UpdatePlatform
  chunkSize?: number
  range?: [Date, Date]
  moId?: Id
}

export interface ExportStatus {
  isExporting: boolean
  done: boolean
  errorMessage?: string
  size?: string
  authCode?: string
  importPassword?: string
}

export interface ImportStatus {
  isImporting: boolean
  done: boolean
  errorMessage?: string
}

export interface ExportMetaInfo {
  exportSettings: ExportOpts
  distroInfo?: Update
  moName?: string
  createdBy: string | undefined
  storageInfo: StorageInfo
  files: string[]
  exportedAt: Date
}

export interface ToolsService {
  readonly exportStatus: ObservableValue<ExportStatus | undefined, Context>
  readonly importStatus: ObservableValue<ImportStatus | undefined, Context>

  export(ctx: Context, opts: ExportOpts): Promise<void>
  importData(ctx: Context, password: string, path: string): Promise<void>
  parseMeta(ctx: Context, path: string): Promise<ExportMetaInfo | undefined>
  pickDirectory(ctx: Context): Promise<string | undefined>
  currentAppType(ctx: Context): AppType
  getDownloadLink(ctx: Context, platform: UpdatePlatform): Promise<string | undefined>
}
